import { CustomResponse } from "../model/data/common";
import { CreateConversationRequest } from "../model/data/messaging";
import { Conversation } from "../model/domain/messaging";
import TaskBase from "./TaskBase";
import Urls from "./Urls";
import {Role} from "@cuatroochenta/co-admin-react-library";

export default class TaskMessaging extends TaskBase {

    public getConversations(url: string) {
        return fetch(Urls.URL_GET_CONVERSATIONS + url + `&center_id=${this.selectedCenter}&role_id=${Role.ADMIN}`, this.getRequestInfo())
            .then(response => response.json())
            .then(data => {return data});
    }

    public getMessages(url: string) {
        return fetch(`${Urls.URL_GET_CONVERSATIONS}/${url}`, this.getRequestInfo())
            .then(response => response.json())
            .then(data => {return data});
    }

    public getMessagingGroups() {
        return fetch(`${Urls.URL_GET_MESSAGING_GROUP}?center_id=${this.selectedCenter}`, this.getRequestInfo())
            .then(response => response.json())
            .then(data => {return data});
    }

    public createConversation(request: CreateConversationRequest) {
        const baseUrl = Urls.URL_GET_CONVERSATIONS;

        return fetch(baseUrl, {
            ...this.getRequestInfo(),
            method: 'POST',
            body: JSON.stringify(request),
        })
            .then((response: Response) => response.json())
            .then((response: CustomResponse<Conversation>) => {
                if (!response.success) {
                    throw new Error(
                        Array.isArray(response.error)
                            ? response.error[0]
                            : response.error
                    )
                }

                return response.data!
            })
            .catch((error) => {
                console.error('Error creating conversation:', error)
                throw error
            });
    }

    public replyConversation(id: number, data: string) {
        const url = `${Urls.URL_GET_CONVERSATIONS}/${id}/message`;
        const body = {
            body: data,
            roleId: Role.ADMIN
        };

        const requestInfo = {
            ...this.getRequestInfo(),
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json', 
                ...this.getRequestInfo().headers,
            },
            body: JSON.stringify(body), 
        };

        return fetch(url, requestInfo)
            .then(response => response.json())
            .then(data => {
                console.log("data: " + JSON.stringify(data));
                return data;
            })
            .catch(error => {
                console.error('Error al contestar a la conversación:', error);
                throw error;
            });
    }

    public removeConversation(conversationId: number) {
        const url = `${Urls.URL_GET_CONVERSATIONS}/${conversationId}`;
        const requestInfo = {
            ...this.getRequestInfo(),
            method: 'DELETE', 
            headers: {
                ...this.getRequestInfo().headers
            }
        };
    
        return fetch(url, requestInfo)
            .then(response => {
                if (!response.ok) {
                    return response.json().then((data) => {
                        throw new Error(data.message || 'Error al eliminar la conversación');
                    });
                }
                return response.json();
            })
            .then(data => {
                return data;
            })
            .catch(error => {
                console.error('Error al eliminar la conversación:', error);
                throw error;
            });
    }
}